export default {
  layout: {
    aiCommandCentre: {
      badge: 'Centro de comando IA',
      line:
        'Asignación autónoma a transportistas y conductores, planificación de rutas con agentes, alertas inteligentes y agentes de IA — una torre de control que ejecuta la logística por ti.',
      cta: 'Agentes IA',
    },
  },
};
